module.exports = __webpack_public_path__ + "static/img/signupbg.799112f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Signup/signupbg.png
// module id = TLzj
// module chunks = 37